<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ptx1xL/images/Cover.jpg?1689450801119" alt="This image is the cover for the book Mighty Morphin Power Rangers: Recharged Vol. 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mighty Morphin Power Rangers: Recharged Vol. 1
      </h1>
      <p class="bookDescription body article font2">
        <p>When a Ranger is forced to make a decision that will forever change the Power Rangers, what will their legacy become? As stories end and converge, and new beginnings arise, join the Power Rangers and kick off a brand new journey! News of a deathly threat reaches the team—one that threatens every Ranger, Earth, and even a home long since destroyed. As the climactic battle against unspeakable enemies unfolds, the lines between friend and foe blur, and difficult decisions await even the strongest of Rangers. The epic culmination of a story years in the making… and as with all endings, a new beginning! Writer Ryan Parrott (Go Go Power Rangers) delivers the final issue on the main series, joined by a superstar lineup of returning artists including Dan Mora (Once &amp; Future), Marco Renna (Power Rangers), Moisés Hidalgo (Dark Blood), Hendry Prasetya (Wonder Woman: Agent of Peace), Daniele Di Nicuolo (Seven Secrets), Eleonora Carlini (Marauders), Francesco Mortarino (Dune: The Waters of Kanly), and Miguel Mercado (X-Force)! Collects Mighty Morphin Power Rangers #100-102.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ryan Parrott, Dan Mora
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59e17d5e